import { useState } from 'react';
import ViewStaffComplianceForm from './ViewStaffComplianceForm';
// Import this component
import ComplianceSelectBox from './ComplianceSelectBox';
import ViewStaffComplianceOnBoarding from '../ui/ViewStaffComplianceCardOnBoarding';
import complianceApi from '../../api/complianceApi';
import { IUpdateStaffInStaffCompliance } from '../../type/updateStaff';
import useLocationStore from '../../store/locatonStore';
import { toast } from 'react-toastify';
import { COMPLIANCE_STATUS } from '../../constants/constant';

interface StaffComplianceCardProps {
  compliance: string;
  category: string;
  status: string;
  allocatedTo: string;
  complianceId?: number;
  complianceCategoryStatus: string;
  name?: string;
  recurrency?: string;
  complianceLink?: string;
  staffId?: number;
  note?: string;
  nextComplianceDate?: string;
  lastComplianceDateDisplay?: string;
  isEditMode?: boolean;
  refetchComplianceDetails: () => void;
  isUserCanEditStaffCompliance?: boolean;
  parentStaffId?: number;
  upcomingDays?: number;
  userHavePermissionToReadStatusStaffCompliance?: boolean;
}

export default function StaffComplianceCard({
  compliance,
  category,
  status,
  allocatedTo,
  complianceId,
  complianceCategoryStatus,
  name,
  recurrency,
  complianceLink,
  staffId,
  note,
  nextComplianceDate,
  lastComplianceDateDisplay,
  isEditMode,
  refetchComplianceDetails,
  isUserCanEditStaffCompliance,
  parentStaffId,
  upcomingDays,
  userHavePermissionToReadStatusStaffCompliance,
}: StaffComplianceCardProps) {
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const setSelectedLocation = useLocationStore(
    (state) => state.setSelectedLocation,
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const isOnboarding = status === 'Onboarding';
  const [updatesStaffId, setUpdatesStaffId] = useState<number | undefined>(
    staffId,
  );

  const updateStaffInStaffCompliance = async (
    data: IUpdateStaffInStaffCompliance[],
  ) => {
    try {
      const response = await complianceApi.updateStaffInStaffCompliance(data);
      console.log(response);
      toast.success('Details updated successfully');
      refetchComplianceDetails();
    } catch (error) {
      console.log(error);
      toast.warn('Details not updated');
    }
  };

  const handleStaffChange = (selectedStaffId: number) => {
    const data: IUpdateStaffInStaffCompliance = {
      staffId: parentStaffId,
      allocStaffId: selectedStaffId,
      ownerId: selectedLocation?.OwnerId,
      complianceId: complianceId,
    };
    updateStaffInStaffCompliance([data]);
  };

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-6 gap-x-6 text-start text-sm">
        <div className="flex flex-col">
          <p className="font-medium text-textColorGray">Compliance</p>
          <p className="text-text-black">{compliance}</p>
        </div>
        <div className="flex flex-col">
          <p className="font-medium text-textColorGray">Category</p>
          <p className="text-text-black">{complianceCategoryStatus}</p>
        </div>
        <div className="flex flex-col cursor-pointer" onClick={handleOpenModal}>
          <p className="font-medium text-textColorGray">Status</p>
          <p
            className={`${
              userHavePermissionToReadStatusStaffCompliance
                ? 'underline decoration-2'
                : ''
            } ${
              (upcomingDays ?? 0) <= 7
                ? 'text-red-500'
                : (upcomingDays ?? 0) <= 30
                  ? 'text-yellow-500'
                  : 'text-gray-700'
            }`}
          >
            {status}
          </p>
        </div>
        <ComplianceSelectBox
          disabled={!isEditMode}
          onChange={(e) => {
            const selectedStaffId = Number(e.target.value);
            console.log('Selected staffId:', selectedStaffId);
            setUpdatesStaffId(selectedStaffId);
            handleStaffChange(selectedStaffId); // Update the state
          }}
          allocatedStaffId={updatesStaffId}
          isEditMode={isEditMode}
        />
      </div>

      {isModalOpen && userHavePermissionToReadStatusStaffCompliance&& (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center px-4">
          {isOnboarding ? (
            <ViewStaffComplianceOnBoarding
              name={name}
              compliance={compliance}
              category={category}
              recurrency={recurrency}
              status={status}
              complianceLink={complianceLink}
              closeModal={handleCloseModal}
              staffId={staffId}
              complianceId={complianceId}
              note={note}
              nextComplianceDate={nextComplianceDate}
              lastComplianceDateDisplay={lastComplianceDateDisplay}
            />
          ) : (
            <ViewStaffComplianceForm
              note={note}
              recurrency={recurrency}
              complianceLink={complianceLink}
              closeModal={handleCloseModal}
              name={name}
              compliance={compliance}
              status={status}
              nextComplianceDate={nextComplianceDate}
              lastComplianceDateDisplay={lastComplianceDateDisplay}
              category={category}
              complianceId={complianceId}
              staffId={staffId}
              onSubmitSuccess={refetchComplianceDetails}
              isUserCanEditStaffCompliance={isUserCanEditStaffCompliance}
            />
          )}
        </div>
      )}
    </>
  );
}
